/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTextMultiline from 'base/components/standalone/TextMultiline';

export const DynamicStandaloneTextMultiline = StandaloneTextMultiline;
export type DynamicStandaloneTextMultilineProps = PropsFromComponent<typeof StandaloneTextMultiline>;

export const DynamicStandaloneTextMultilineWith = (extras: DynamicStandaloneExtras): typeof StandaloneTextMultiline => {
    return function DynamicStandaloneTextMultiline(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TextMultiline');
        return <StandaloneTextMultiline {...mergeProps({ options: { theme } }, props)} />;
    }
}